import { startPollingMessages } from './startPollingMessages';
import { updateRecommendations as updateRecommendationsService } from '../../services/updateRecommendations';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

export const updateRecommendations = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const result = await updateRecommendationsService(context);

  /* istanbul ignore next */
  if (!result) {
    dispatch(showAlert({ message: 'Не получилось, попробуйте ещё раз' }));

    return;
  }

  dispatch(startPollingMessages());
};
